<ng-container *ngrxLet="dropOffState$; let data">
    @switch (data.dropOffPageState) {
        @case (DropOffState.FORM) {
            <base-container [isLoading]="data?.isLoading" id="dataFormDropOff">
                <div
                    [innerHTML]="dropOffData?.txtContent?.details.html"
                    pageHeading></div>
                <form
                    [formGroup]="dataForm"
                    (submit)="dropOff()"
                    id="dataForm"
                    class="mb-8">
                    <div class="mb-4">
                        <lib-input
                            [labelText]="dropOffData?.txtName?.details.label"
                            [validateStatus]="
                                dataForm.controls.firstName?.errors &&
                                dataForm.controls.firstName?.dirty
                                    ? 'error'
                                    : null
                            "
                            [errorMessage]="firstNameErrorMessage()">
                            <input
                                [placeholder]="
                                    dropOffData?.txtName?.details
                                        .placeholderText
                                "
                                libCharacterOnly
                                required
                                nz-input
                                [formControlName]="
                                    dropOffData.txtName.details.formControlName
                                "
                                [maxlength]="
                                    dropOffData?.txtName.details?.validation
                                        ?.maxLength
                                "
                                [disabled]="data?.isLoading"
                                nzSize="large"
                                libWhitespaceValidator
                                libNameSurnameValidator />
                        </lib-input>
                    </div>
                    <div class="mb-4">
                        <lib-input
                            [labelText]="dropOffData?.txtSurname?.details.label"
                            [validateStatus]="
                                dataForm.controls.surname.dirty &&
                                dataForm.controls.surname.errors
                                    ? 'error'
                                    : null
                            "
                            [errorMessage]="surnameErrorMessage()">
                            <input
                                [placeholder]="
                                    dropOffData?.txtSurname?.details
                                        .placeholderText
                                "
                                nz-input
                                libCharacterOnly
                                required
                                [formControlName]="
                                    dropOffData.txtSurname.details
                                        .formControlName
                                "
                                [maxlength]="
                                    dropOffData?.txtSurname.details?.validation
                                        ?.maxLength
                                "
                                [disabled]="data?.isLoading"
                                nzSize="large"
                                libWhitespaceValidator
                                libNameSurnameValidator />
                        </lib-input>
                    </div>
                    <div class="mb-4">
                        <lib-input
                            [labelText]="dropOffData?.txtNumber?.details.label"
                            [validateStatus]="
                                dataForm.controls.contactNumber.dirty &&
                                dataForm.controls.contactNumber.errors
                                    ? 'error'
                                    : null
                            "
                            [errorMessage]="contactNumberErrorMessage()">
                            <input
                                [placeholder]="
                                    dropOffData?.txtNumber?.details
                                        .placeholderText
                                "
                                nz-input
                                [maxlength]="
                                    dropOffData.txtNumber.details?.validation
                                        ?.maxLength ?? 10
                                "
                                [minlength]="
                                    dropOffData.txtNumber.details?.validation
                                        ?.minLength ?? 10
                                "
                                required
                                [disabled]="data?.isLoading"
                                libValidateCellNumber
                                libNumbersOnly
                                [formControlName]="
                                    dropOffData.txtNumber.details
                                        .formControlName
                                "
                                nzSize="large"
                                libWhitespaceValidator
                                [isMasked]="isMasked" />
                        </lib-input>
                    </div>
                </form>
                <ng-container buttons>
                    <button
                        (click)="dropOff()"
                        [disabled]="!dataForm.valid || data?.isLoading"
                        class="w-full fu-btn-primary"
                        nz-button
                        nzSize="large"
                        nzType="primary">
                        {{
                            data?.isLoading
                                ? (dropOffData?.btnCallbackLoading?.details
                                      ?.label ?? 'Sending details...')
                                : dropOffData?.btnCallback?.details?.label
                        }}
                    </button>
                </ng-container>
            </base-container>
        }
        @case (DropOffState.COMPLETE) {
            <base-container>
                <div class="text-center flex flex-col items-center mt-6 px-6">
                    @if (dropOffCompleteData?.imgDropOff) {
                        <div
                            [innerHTML]="
                                dropOffCompleteData?.imgDropOff.details.html
                                    | replace: additionalData
                            "></div>
                    }
                    <div
                        [innerHTML]="
                            isResumeQuote
                                ? (dropOffCompleteData
                                      ?.txtHeadingWithOutThankYou?.details.html
                                  | replace: additionalData)
                                : shouldIncludeName()
                                  ? (dropOffCompleteData?.txtHeadingWithName
                                        ?.details.html
                                    | replace: additionalData)
                                  : dropOffCompleteData?.txtHeadingWithoutName
                                        ?.details.html
                        "></div>

                    <div
                        [innerHTML]="
                            dropOffCompleteData?.txtContent?.details.html
                                | replace: txtContentReplaceData()
                        "></div>
                </div>
                <ng-container buttons>
                    <button
                        (click)="goTo()"
                        class="w-full fu-btn-primary"
                        nz-button
                        nzSize="large"
                        nzType="primary">
                        {{ getButtonText() }}
                    </button>
                </ng-container>
            </base-container>
        }
        @case (DropOffState.LOADING) {
            <base-container>
                <div
                    libLoader
                    [isLoading]="true"
                    class="mt-4"
                    [theme]="{
                        width: '100%',
                        margin: 0,
                        height: '200px',
                    }"></div>
            </base-container>
        }
    }
</ng-container>
